import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import { useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useDispatch } from "react-redux";
import {
  AddTaxDeclarationAction,
  GetTaxDeclarationAction,
  UpdateTaxDeclarationAction,
} from "../../../../../store/Finance/TaxDeclaration/Action";
import TDStep1 from "./TDStep1";
import TDStep2 from "./TDStep2";
import { useTheme } from "@mui/material/styles";
import { UpdateEmployeeTaxDeclarationHelper } from "../../helper/TaxDeclarationHelper";
import { makeStyles, createStyles } from "@mui/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { currentMonth } from "../../../Base/helper/baseFunctions";
import history from "../../../../../history";
import TDStep5 from "./TDStep5";
import TDStep3 from "./TDStep3";
import TDStep4 from "./TDStep4";

const TaxSummary = ({
  data,
  activeStep,
  setActiveStep,
  regimeData,
  checkViewType,
  defaultValue,
  updatedData,
  comments,
  checkDeclarationStatus,
  declarationStatus,
}) => {
  const theme = useTheme();
  const actionSummaryStyle = {
    marginTop: "1%",
    minHeight: 50,
    maxHeight: 50,
    borderRadius: "10px 10px 0px 0px",
    "&.Mui-expanded": {
      minHeight: 50,
      maxHeight: 50,
      backgroundColor: theme?.palette?.primary?.dark,
      color: "white",
    },
  };
  const useStyles = makeStyles((theme) =>
    createStyles({
      paper: {
        width: "80%",
        margin: "auto",
        backgroundColor: "#f3edfd",
        boxShadow:
          "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "10px 20px",
        borderRadius: "10px",
        color: "black",
        marginTop: "10px",
      },
      paper2: {
        width: "50%",
        marginLeft: "10%",
        backgroundColor: "#f3edfd",
        boxShadow:
          "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        padding: "10px 50px 10px 20px",
        borderRadius: "10px",
        color: "black",
        marginTop: "10px",
      },
    })
  );
  const classes = useStyles();
  const [expanded, setExpanded] = useState(
    regimeData?.regime === "old_regime" ? 1 : 4
  );
  const dispatch = useDispatch();
  const { disable_ap } = checkDeclarationStatus || {};
  const [checked, setChecked] = useState(false);
  const sectionsOld = [
    {
      name: "Section 80C",
      step: "step1",
      data: data?.step1,
      data2: updatedData?.stepUpdate1,
    },
    {
      name: "Other Chapter VIA",
      step: "step2",
      data: data?.step2,
      data2: updatedData?.stepUpdate2,
    },
    {
      name: "House Rent Exemption",
      step: "step3",
      data: data?.step3,
      data2: updatedData?.stepUpdate3,
    },
    {
      name: "Section 24",
      step: "step4",
      data: data?.step4,
      data2: updatedData?.stepUpdate4,
    },
    {
      name: "Other Details",
      step: "step5",
      data: data?.step5,
      data2: updatedData?.stepUpdate5,
    },
  ];
  const sectionsNew = [
    {
      name: "Section 24",
      step: "step4",
      data: data?.step4,
      data2: updatedData?.stepUpdate4,
    },
  ];
  const { sectionRows, hasMismatch } = processSections(
    regimeData?.regime === "old_regime" ? sectionsOld : sectionsNew
  );

  const notReqComponents = {
    et_80c_epf: null,
    et_80c_scss: null,
    et_80c_sa_fund: null,
    et_80c_nhb: null,
    et_80c_nabard: null,
    et_80d_md: null,
    et_80d_ph: null,
    et_80g: null,
    et_24b_old: null,
    et_24b_new: null,
    et_24b_property_type_old: null,
    et_24b_property_type_new: null,
  };
  const handleSubmit = () => {
    ["step1", "step2", "step5"]?.forEach((step) => {
      if (data?.[step]) {
        Object.keys(data[step]).forEach((key) => {
          if (data[step][key] === "") {
            data[step][key] = null;
          }
        });
      }
    });
    const taxdata = {
      id: data?.taxDeclaration_data?.[0]?.emp_tax_declaration_id,
      month: currentMonth(),
      emptd_approver_status: data?.taxDeclaration_data?.[0]
        ?.emp_tax_declaration_id
        ? "Action Needed"
        : "To be verified",
      emplp: JSON.stringify(data?.step3),
      emphp: JSON.stringify(data?.step4),
      emptd: JSON.stringify([
        {
          ...notReqComponents,
          ...data?.step1,
          ...data?.step2,
          ...data?.step5,
          status: data?.taxDeclaration_data?.[0]?.emp_tax_declaration_id
            ? "Completed"
            : "To be verified",
          approved_date: null,
          year: new Date().getFullYear(),
          preferred_regime: data?.regimeData?.regime,
        },
      ]),
    };

    if (data?.taxDeclaration_data?.[0]?.emp_tax_declaration_id)
      dispatch(UpdateTaxDeclarationAction(taxdata));
    else dispatch(AddTaxDeclarationAction(taxdata));
  };
  const handleUpdateEmployee = () => {
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(
      today.getMonth() + 1
    ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

    // Validate all steps in `updatedData`: Replace empty string values with null
    ["stepUpdate1", "stepUpdate2", "stepUpdate5"].forEach((step) => {
      if (updatedData?.[step]) {
        Object.keys(updatedData[step]).forEach((key) => {
          if (updatedData[step][key] === "") {
            updatedData[step][key] = null;
          }
        });
      }
    });

    const updated_data = {
      employee_id: defaultValue?.employee_id,
      emp_tax_declaration_approved_id:
        defaultValue.emp_tax_declaration_approved_id,
      emp_status: hasMismatch ? "Action Needed" : "Completed",
      emplp: JSON.stringify(updatedData?.stepUpdate3),
      emphp: JSON.stringify(updatedData?.stepUpdate4),
      month: currentMonth(),
      year: new Date().getFullYear(),
      emptd: JSON.stringify([
        {
          ...updatedData?.stepUpdate1,
          ...updatedData?.stepUpdate2,
          ...updatedData?.stepUpdate5,
          comment_approved: JSON.stringify([{ ...comments }]),
          status_approved: "Completed",
          Approved_date_approved: formattedDate,
          preferred_regime_approved: regimeData?.regime,
        },
      ]),
    };
    UpdateEmployeeTaxDeclarationHelper(updated_data).then((res) => {
      if (res?.data?.statuscode === 200) {
        dispatch(
          GetTaxDeclarationAction({ employee_id: defaultValue?.employee_id })
        );
        history.push({
          pathname: "/team-tax-declaration",
          state: { tab: 2 },
        });
      }
    });
  };

  const { totalDeclaredDeductions, totalApprovedDeductions } = calculateTotals(
    regimeData?.regime,
    sectionsOld,
    sectionsNew,
    defaultValue?.ctc
  );

  return (
    <>
      {!checkViewType ? (
        <Box>
          <Typography variant="h6">Summary</Typography>
          {data?.step1 &&
            data?.regimeData?.regime === "old_regime" &&
            Object.values(data?.step1).length > 0 && (
              <Accordion
                expanded={expanded === 1}
                onChange={(e) =>
                  expanded === 1 ? setExpanded("") : setExpanded(1)
                }
                sx={{ borderRadius: "10px" }}
              >
                <AccordionSummary
                  expandIcon={<KeyboardArrowDownIcon />}
                  id="controlled-panel-header-1"
                  aria-controls="controlled-panel-content-1"
                  sx={actionSummaryStyle}
                >
                  <Typography
                    sx={{ color: theme.palette.primary.contrastText }}
                    fontWeight={600}
                    variant="body1"
                  >
                    Section 80C
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TDStep1 disableEdit={true} step1={data?.step1} />
                </AccordionDetails>
              </Accordion>
            )}
          {data?.step2 &&
            data?.regimeData?.regime === "old_regime" &&
            Object.values(data?.step2).length > 0 && (
              <Accordion
                expanded={expanded === 2}
                onChange={(e) =>
                  expanded === 2 ? setExpanded("") : setExpanded(2)
                }
                sx={{ borderRadius: "10px" }}
              >
                <AccordionSummary
                  expandIcon={<KeyboardArrowDownIcon />}
                  id="controlled-panel-header-1"
                  aria-controls="controlled-panel-content-1"
                  sx={actionSummaryStyle}
                >
                  <Typography
                    sx={{ color: theme.palette.primary.contrastText }}
                    fontWeight={600}
                    variant="body1"
                  >
                    Other Chapter VIA
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TDStep2 disableEdit={true} step2={data?.step2} />
                </AccordionDetails>
              </Accordion>
            )}
          {data?.step3 &&
            data?.regimeData?.regime === "old_regime" &&
            Object.values(data?.step3).length > 0 && (
              <Accordion
                expanded={expanded === 3}
                onChange={(e) =>
                  expanded === 3 ? setExpanded("") : setExpanded(3)
                }
                sx={{ borderRadius: "10px" }}
              >
                <AccordionSummary
                  expandIcon={<KeyboardArrowDownIcon />}
                  id="controlled-panel-header-1"
                  aria-controls="controlled-panel-content-1"
                  sx={actionSummaryStyle}
                >
                  <Typography
                    sx={{ color: theme.palette.primary.contrastText }}
                    fontWeight={600}
                    variant="body1"
                  >
                    House Rent Exemption
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TDStep3
                    step3={data?.step3}
                    disableEdit={true}
                    checkDeclarationStatus={checkDeclarationStatus}
                    stepUpdate3={updatedData?.stepUpdate3}
                  />
                </AccordionDetails>
              </Accordion>
            )}
          {data?.step4 && Object.values(data?.step4).length > 0 && (
            <Accordion
              expanded={expanded === 4}
              onChange={(e) =>
                expanded === 4 ? setExpanded("") : setExpanded(4)
              }
              sx={{ borderRadius: "10px" }}
            >
              <AccordionSummary
                expandIcon={<KeyboardArrowDownIcon />}
                id="controlled-panel-header-1"
                aria-controls="controlled-panel-content-1"
                sx={actionSummaryStyle}
              >
                <Typography
                  sx={{ color: theme.palette.primary.contrastText }}
                  fontWeight={600}
                  variant="body1"
                >
                  Section 24
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <TDStep4
                  step4={data?.step4}
                  disableEdit={true}
                  checkDeclarationStatus={checkDeclarationStatus}
                  stepUpdate4={updatedData?.stepUpdate4}
                  regimeData={regimeData}
                />
              </AccordionDetails>
            </Accordion>
          )}
          {data?.step5 &&
            data?.regimeData?.regime === "old_regime" &&
            Object.values(data?.step5)?.length > 0 && (
              <Accordion
                expanded={expanded === 5}
                onChange={(e) =>
                  expanded === 5 ? setExpanded("") : setExpanded(5)
                }
                sx={{ borderRadius: "10px" }}
              >
                <AccordionSummary
                  expandIcon={<KeyboardArrowDownIcon />}
                  id="controlled-panel-header-1"
                  aria-controls="controlled-panel-content-1"
                  sx={actionSummaryStyle}
                >
                  <Typography
                    sx={{ color: theme.palette.primary.contrastText }}
                    fontWeight={600}
                    variant="body1"
                  >
                    Other Details
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TDStep5 step5={data?.step5} disableEdit={true} />
                </AccordionDetails>
              </Accordion>
            )}
          {!disable_ap && (
            <Box
              sx={{
                border: "1px solid #ccc",
                padding: 2,
                borderRadius: 2,
                width: "100%",
                backgroundColor: "#f9f9f9",
              }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={(e) => setChecked(e.target.checked)}
                  />
                }
                label={
                  <>
                    <Typography
                      sx={{
                        display: "block",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      I confirm that the details I have provided regarding my
                      tax-saving investments and deductions (such as Section
                      80C, 80D, 80G and 24(b), etc.) are accurate. I understand
                      that I am required to submit valid proof in a timely
                      manner and that any discrepancies may result in additional
                      tax being deducted in accordance with applicable
                      regulations.
                    </Typography>
                  </>
                }
                sx={{ alignItems: "flex-start", width: "100%" }}
              />
            </Box>
          )}
        </Box>
      ) : (
        <>
          <Box className={classes.paper}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Admin Summary
            </Typography>
            <Grid container spacing={2}>
              {/* Header Row */}
              <Grid item xs={3}>
                <Typography variant="h6">Section Name</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography textAlign={"center"} variant="h6">
                  Declared Amount
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography textAlign={"center"} variant="h6">
                  Approved Amount
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography textAlign={"center"} variant="h6">
                  Remarks
                </Typography>
              </Grid>
              {/* Section Rows */}
              {sectionRows}
            </Grid>
          </Box>

          <Box className={classes.paper2}>
            {/* Total Summary Row */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 1 }}
            >
              <Typography fontWeight="bold">
                Total Declared Deductions:
              </Typography>
              <Typography>{totalDeclaredDeductions}</Typography>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 1 }}
            >
              <Typography fontWeight="bold">
                Total Approved Deductions:
              </Typography>
              <Typography>{totalApprovedDeductions}</Typography>
            </Box>
          </Box>
        </>
      )}

      <Box
        sx={{ display: "flex", justifyContent: "space-between", bottom: 30 }}
      >
        {activeStep !== 0 && (
          <Button
            sx={{ marginRight: "10px", mt: 5 }}
            type="submit"
            variant="contained"
            className="mpl-primary-btn"
            size="medium"
            onClick={() =>
              regimeData?.regime !== "new_regime"
                ? setActiveStep(activeStep - 1)
                : setActiveStep(activeStep - 2)
            }
          >
            Back
          </Button>
        )}
        {checkViewType ? (
          <>
            {/* /// admin */}
            <Button
              sx={{ marginRight: "10px", mt: 5 }}
              size="medium"
              variant="contained"
              className="mpl-primary-btn"
              onClick={() => handleUpdateEmployee()}
            >
              Save
            </Button>
          </>
        ) : (
          <>
            {!disable_ap && (
              <Button
                sx={{ marginRight: "10px", mt: 5 }}
                size="medium"
                variant="contained"
                disabled={!checked}
                className="mpl-primary-btn"
                onClick={() => handleSubmit()}
              >
                Save
              </Button>
            )}
          </>
        )}
      </Box>
    </>
  );
};

export default TaxSummary;

const sumFromData = (stepName, data) => {
  if (!data) return 0;

  if (Array.isArray(data)) {
    switch (stepName) {
      case "step3":
        return data?.reduce(
          (acc, item) => acc + (parseFloat(item?.rent_per_month) || 0),
          0
        );
      case "step4":
        return data?.reduce((acc, item) => {
          const principal = parseFloat(item?.principal_amount || 0);
          const interest = parseFloat(item?.interest_amount || 0);
          return acc + principal + interest;
        }, 0);
      case "step3_approved":
        return data?.reduce(
          (acc, item) => acc + (parseFloat(item?.rent_per_month_approved) || 0),
          0
        );
      case "step4_approved":
        return data?.reduce((acc, item) => {
          const principal = parseFloat(item?.principal_amount_approved || 0);
          const interest = parseFloat(item?.interest_amount_approved || 0);
          return acc + principal + interest;
        }, 0);
      default:
        return 0;
    }
  } else if (typeof data === "object") {
    return Object.values(data || {}).reduce(
      (acc, value) => acc + (parseFloat(value) || 0),
      0
    );
  }

  return 0;
};

const calculateTotals = (regime, sectionsOld, sectionsNew, grossIncome) => {
  const sections = regime === "old_regime" ? sectionsOld : sectionsNew;

  const totalDeclaredDeductions = sections.reduce((total, section) => {
    const step = section.step || "";
    return total + sumFromData(step, section.data);
  }, 0);

  const totalApprovedDeductions = sections.reduce((total, section) => {
    const step = section?.step || "";
    return total + sumFromData(`${step}_approved`, section?.data2);
  }, 0);

  const taxableIncomeAfterDeduction = grossIncome - totalApprovedDeductions;

  const estimatedTDSPerMonth = (
    (taxableIncomeAfterDeduction * 0.2) /
    12
  ).toFixed(2);

  return {
    totalDeclaredDeductions,
    totalApprovedDeductions,
    taxableIncomeAfterDeduction,
    estimatedTDSPerMonth,
  };
};

const processSections = (sections) => {
  let hasMismatch = false;

  const sectionRows = sections?.map((section) => {
    const stepName = section.step || "";

    const sumOfDeclaredValues = sumFromData(stepName, section?.data);
    const sumOfApprovedValue = sumFromData(
      `${stepName}_approved`,
      section?.data2
    );

    // Check for mismatch
    if (sumOfDeclaredValues !== sumOfApprovedValue) {
      hasMismatch = true;
    }

    return (
      <React.Fragment key={section.name}>
        <Grid item xs={3}>
          <Typography color={"inherit"} fontWeight={"bold"} variant="body2">
            {section.name}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography color={"inherit"} textAlign={"center"} variant="body2">
            {sumOfDeclaredValues}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography color={"inherit"} textAlign={"center"} variant="body2">
            {sumOfApprovedValue}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          {sumOfDeclaredValues === sumOfApprovedValue ? (
            <Box display="flex" alignItems="center" justifyContent="center">
              <CheckCircleIcon sx={{ color: "green", mr: 1 }} />
              <Typography color="green" variant="body2">
                Approved
              </Typography>
            </Box>
          ) : (
            <Box display="flex" alignItems="center" justifyContent="center">
              <ReportProblemIcon sx={{ color: "orange", mr: 1 }} />
              <Typography color="orange" variant="body2">
                Adjusted
              </Typography>
            </Box>
          )}
        </Grid>
      </React.Fragment>
    );
  });

  return { sectionRows, hasMismatch };
};
